angular.module('impactx.product').controller('ProductDialogCtrl', [
    '$scope',
    '$routeParams',
    'ProductFactory',
    'panelService', '$config',
    '$mdPanel',
    '$redirect',
    'SearchFilter',
    '$securityManager',
    'SearchService',
    'ToolbarService',
    'AppConfiguration',
    'SearchFilterStorage',
    'searchFilter',
    'FileHelperService',
    'OCICatalogService',
    'ProductViewService',
    'ThemeWorldService',
    'TranslationService',
    '$context',
    'ixaSearchSignals',
    'ProductEuelService',
    '$rootScope',
    '$location',
    'ixaProductComparison',
    ProductController
]);

function ProductController($scope, $routeParams, ProductFactory, panelService, $config, $mdPanel, $redirect, SearchFilter,
                           $securityManager, SearchService, ToolbarService, AppConfiguration, SearchFilterStorage, searchFilter, FileHelperService, OCICatalogService,
                           ProductViewService, ThemeWorldService, TranslationService, $context, ixaSearchSignals, ProductEuelService, $rootScope, $location, ixaProductComparison) {
    var isUnite = $location.path().indexOf('/productunite/') === 0;
    var vm = this,
        productFactory = ProductFactory.new(isUnite ? $routeParams.externalId : $routeParams.id, $routeParams.preConfigured && $routeParams.preConfigured !== "false", $routeParams.oldBKIId ? $routeParams.oldBKIId : 0, $routeParams.selectedVariantPatIds ? $routeParams.selectedVariantPatIds.split(",") : null, isUnite, $routeParams.catId, $routeParams.vCatId ? +$routeParams.vCatId : 0);
    $scope.configDisabled = false;
    vm.productDataSheetLabel = TranslationService.get("productDataSheet");
    vm.productEuelService = ProductEuelService;
    vm.lastTopIndexProductSearch = SearchService.lastTopIndexProductSearch.value;
    vm.noWhiteframe = AppConfiguration.get('noWhiteFrameInProductDialog');
    SearchService.lastTopIndexProductSearch.value = 0;
    $scope.highlightSearchText = AppConfiguration.get('useSearchHighlighting') && $routeParams.highlightSearchText && $routeParams.highlightSearchText === "true";
    vm.showPanelLabel = AppConfiguration.get('showPanelLabels');

    $scope.oldBKIId = $routeParams.oldBKIId;
    $scope.vCatId = $routeParams.vCatId;
    vm.setLastTopIndexForProductList = function () {
        SearchService.consumableTopIndexProductSearch.value = vm.lastTopIndexProductSearch;
    };
    vm.getProductPanelColor = panelService.getProductPanelColor;
    vm.secManager = $securityManager;
    this.addToFavorites = function () {
        productFactory.addToFavorites();
    };

    this.removeFromFavorites = function () {
        productFactory.removeFromFavorites();
    };

    this.addToComparison = function () {
        productFactory.addToComparison();
    };

    this.addFreeForm = function () {
        productFactory.addFreeform();
    };

    this.addExternalProductToBasket = function (event) {
        var amount = vm.model.product.basketLink.amount || vm.model.product.basketLink.price.minAmount || 1;
        productFactory.addExternalProductToBasket(event, amount);
    };

    this.replaceInBasket = function () {
        productFactory.replaceInBasket(vm.model.trns.replaceInBasketActionLabel);
    };

    this.toExternalCat = function () {
        if (impactX.isDefined(this.model, "product.vcatalog.catalog.isExternal")) {
            OCICatalogService.toExternalCat(this.model.product.vcatalog.catalog);
        }
    };

    this.model = {};

    this.openEClassSearchPanel = function (event) {
        searchFilter.searchInput = "";
        searchFilter.searchInputGlobal = "";
        SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
        SearchFilter.setGuidingClassification(impactX.isDefined(this, "model.product.eClass"));
        searchFilter.resetDetailFilter().then(function () {
            $redirect.redirectTo(null, "/search");
        });
    };

    $scope.$watchCollection('proDialogCtrl.model.config.drillDowns', function (oldValue, newValue) {
        var changed = false;
        if (newValue) {
            angular.forEach(oldValue, function (value, key) {

                if (newValue[key] && value) {
                    if (newValue[key].pathHashString !== value.pathHashString) {
                        changed = true;
                    }
                }
                else if (newValue[key] && !value) {
                    changed = true;
                }
                else if (!newValue[key] && value) {
                    changed = true;
                }
            });
        }
        if (changed) {
            $scope.configDisabled = true;
            vm.check().finally(function () {
                $scope.configDisabled = false;
            });
        }
    });

    ProductController.prototype.check = function () {
        return productFactory.check();
    };

    ProductController.prototype.selectProduct = function (add) {
        productFactory.selectProduct(add).then(vm.updateData);
    };

    ProductController.prototype.selectConfig = function (imageConfig) {
        productFactory.selectConfig(imageConfig);
    };

    ProductController.prototype.getProductData = function (id) {
        productFactory.getProductData(id).then(vm.updateData);
    };

    ProductController.prototype.updateData = function () {
        vm.model = productFactory.model;
    };

    var backButtonUsed = $rootScope.location !== $location.path();
    productFactory.getProductData()
        .then(productFactory.getConfiguration)
        .then(vm.updateData)
        .then(function () {
            defineButtons();
            const proId = vm.model.product.groupNumber > 0? vm.model.product.groupNumber : vm.model.product.id;
            ixaSearchSignals.select(proId);
            ixaSearchSignals.startRead(vm.model.product.id, angular.element('#main-content'));
            if(backButtonUsed) {
                SearchFilterStorage.scrollToSearchScrollPosition("product", '#main-content');
            }
        });

    $scope.$on('$routeChangeStart', function (event, newRoute, oldRoute) {
        if (newRoute.$$route.originalPath !== oldRoute.$$route.originalPath) {
            SearchFilterStorage.setSearchScrollPosition("product", document.getElementById('main-content').scrollTop);
        }
    });

    $scope.$on('$destroy', function () {
        ixaSearchSignals.endRead();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: vm.model.trns.addToFavorites,
                action: vm.addToFavorites,
                type: 'dialogaction',
                condition: canAddToFavorites
            },
            {
                label: vm.model.trns.removeFromFavorites,
                action: vm.removeFromFavorites,
                type: 'dialogaction',
                condition: canRemoveFromFavorites
            },
            {
                label: vm.model.trns.addToComparison,
                action: vm.addToComparison,
                type: 'dialogaction',
                condition: canAddToComparison
            },
            {
                labelFunction: function (){return ixaProductComparison.getRedirectButtonLabel()},
                linkFunction: function ()
                {
                    return "productcomparison"
                },
                type: 'link',
                condition: function ()
                {
                    return ixaProductComparison.getProductComparisonCount() > 1
                }
            },
            {
                label: vm.model.trns.replaceInBasket,
                action: vm.replaceInBasket,
                type: 'dialogaction',
                condition: canReplaceInBasket
            },
            {
                label: TranslationService.get('addToProductView'),
                action: vm.addToProductView,
                type: 'dialogaction',
                condition: canAddToProductView
            },
            {
                label: TranslationService.get('removeFromProductView'),
                action: vm.removeFromProductView,
                type: 'dialogaction',
                condition: canRemoveFromProductView
            },
            {
                label: TranslationService.get('addAllToProductView'),
                action: vm.addAllToProductView,
                type: 'dialogaction',
                condition: canAddAllToProductView
            },
            {
                label: TranslationService.get('removeAllFromProductView'),
                action: vm.removeAllFromProductView,
                type: 'dialogaction',
                condition: canRemoveAllFromProductView
            },
            {
                label: TranslationService.get('addToThemeWorld'),
                action: vm.addToThemeWorld,
                type: 'dialogaction',
                condition: canAddToThemeWorld
            },
            {
                label: TranslationService.get('removeFromThemeWorld'),
                action: vm.removeFromThemeWorld,
                type: 'dialogaction',
                condition: canRemoveFromThemeWorld
            },
            {
                label: TranslationService.get('addAllToProductView'),
                action: vm.addAllToThemeWorld,
                type: 'dialogaction',
                condition: canAddAllToThemeWorld
            },
            {
                label: TranslationService.get('removeAllFromProductView'),
                action: vm.removeAllFromThemeWorld,
                type: 'dialogaction',
                condition: canRemoveAllFromThemeWorld
            },
            {
                label: vm.model.trns.print,
                type: 'print',
                condition: function() { return !isUnite; },
                params: {
                    printTokenFunction: getPrintToken
                }
            },
        ];

        ToolbarService.backButtonCallback(vm.setLastTopIndexForProductList);
        ToolbarService.setButtons(buttonDefinition);
    }

    vm.addToThemeWorld = function() {
        ThemeWorldService.addProductsToThemeWorld([vm.model.product]);
    };

    vm.addAllToThemeWorld = function() {
        ThemeWorldService.addAllProductConfigsToThemeWorld([vm.model.product]);
    };

    vm.removeFromThemeWorld = function() {
        var proIds = [];
        vm.model.product.basketLink.canAddToThemeWorld = true;
        vm.model.product.basketLink.canRemoveFromThemeWorld = false;
        proIds.push(vm.model.product.id);
        ThemeWorldService.removeProductsFromThemeWorld($context.hasActiveThemeWorld.id, proIds);
    };

    vm.removeAllFromThemeWorld = function() {
        var proIds = [];
        vm.model.product.basketLink.canAddToThemeWorld = true;
        vm.model.product.basketLink.canRemoveFromThemeWorld = false;
        vm.model.product.basketLink.hasOtherConfigurationsInThemeWorld = false;
        vm.model.product.basketLink.hasOtherConfigurationsNotInThemeWorld = true;
        proIds.push(vm.model.product.id);
        ThemeWorldService.removeAllProductConfigsFromThemeWorld($context.hasActiveThemeWorld.id, proIds);
    };

    function canRemoveFromThemeWorld() {
        return vm.model.product && vm.model.product.basketLink && vm.model.product.basketLink.canRemoveFromThemeWorld;
    }

    function canRemoveAllFromThemeWorld() {
        return vm.model.product && vm.model.product.basketLink && vm.model.product.isConfigProduct && (vm.model.product.basketLink.canRemoveFromThemeWorld || vm.model.product.basketLink.hasOtherConfigurationsInThemeWorld);
    }

    function canAddToThemeWorld() {
        return vm.model.product && vm.model.product.basketLink && vm.model.product.basketLink.canAddToThemeWorld;
    }

    function getPrintToken (){
        return vm.model.printTokens.product;
    }

    function canAddAllToThemeWorld() {
        return vm.model.product && vm.model.product.basketLink && vm.model.product.isConfigProduct && (vm.model.product.basketLink.canAddToThemeWorld || vm.model.product.basketLink.hasOtherConfigurationsNotInThemeWorld);
    }

    vm.addToProductView = function(event) {
        ProductViewService.addProductsToProductView([vm.model.product], event);
    };

    vm.addAllToProductView = function(event) {
        ProductViewService.addAllProductConfigsToProductView([vm.model.product], event);
    };

    vm.removeFromProductView = function() {
        var proIds = [];
        vm.model.product.basketLink.canAddToProductView = true;
        vm.model.product.basketLink.canRemoveFromProductView = false;
        proIds.push(vm.model.product.id);
        ProductViewService.removeProductsFromProductView($context.hasActiveProductView.id, proIds);
    };

    vm.removeAllFromProductView = function() {
        var proIds = [];
        vm.model.product.basketLink.canAddToProductView = true;
        vm.model.product.basketLink.canRemoveFromProductView = false;
        vm.model.product.basketLink.hasOtherConfigurationsInProductView = false;
        vm.model.product.basketLink.hasOtherConfigurationsNotInProductView = true;
        proIds.push(vm.model.product.id);
        ProductViewService.removeAllProductConfigsFromProductView($context.hasActiveProductView.id, proIds);
    };

    function canRemoveFromProductView() {
        return vm.model.product && vm.model.product.basketLink && vm.model.product.basketLink.canRemoveFromProductView;
    }

    function canRemoveAllFromProductView() {
        return vm.model.product && vm.model.product.basketLink && vm.model.product.isConfigProduct && (vm.model.product.basketLink.canRemoveFromProductView || vm.model.product.basketLink.hasOtherConfigurationsInProductView);
    }

    function canAddToProductView() {
        return vm.model.product && vm.model.product.basketLink && vm.model.product.basketLink.canAddToProductView;
    }

    function canAddAllToProductView() {
        return vm.model.product && vm.model.product.basketLink && vm.model.product.isConfigProduct && (vm.model.product.basketLink.canAddToProductView || vm.model.product.basketLink.hasOtherConfigurationsNotInProductView);
    }

    function canAddToFavorites() {
        return !isUnite && vm.model.product.canBeAddedToFavorites && !vm.model.product.isFavorite && (!vm.model.product.isConfigProduct || vm.model.config.fullyConfigured);
    }

    function canRemoveFromFavorites() {
        return !isUnite && vm.model.product.canBeAddedToFavorites && vm.model.product.isFavorite && (!vm.model.product.isConfigProduct || vm.model.config.fullyConfigured);
    }

    function canAddToComparison() {
        return vm.model.product.canBeAddedToProductComparison &&
            (!vm.model.product.isConfigProduct || vm.model.config.fullyConfigured)
            && vm.secManager.isProcessAllowed('CompareProducts');
    }

    function canReplaceInBasket() {
        return $scope.oldBKIId > 0 && (!vm.model.product.isConfigProduct || vm.model.config.fullyConfigured);
    }

    this.getFileMdiClass = function (attachment) {
        return FileHelperService.getFileMdiClass(attachment.fileName);
    };

    this.referenceFilterFunc = function () {
        const filterVal = vm.model.product.referenceProductsFilter.selected;
        if(filterVal && filterVal.value)
        {
            vm.refFilterVal = filterVal.value;
        }
        else
        {
            vm.refFilterVal = undefined;
        }
    }
}